import { render, staticRenderFns } from "./IndexPrice.vue?vue&type=template&id=16bd3cda&"
import script from "./IndexPrice.vue?vue&type=script&lang=js&"
export * from "./IndexPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports